import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import { Checkbox, Card, Table, Modal, Icon } from 'antd';
import _notification from 'modules/notification';
import EmptyState from 'components/enterprise/EmptyState';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import ButtonComponent from 'components/controls/Button';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';

class UniversityMaster_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 8, current: 1 },
            highlightedRowID: 0,
            data: [],
            rowData: { IsBoard: false, IsDiploma: false },
            loading: false,
            showModel: false,
            showMessageBox: false,
            nameError: "",
        };
    }

    componentDidMount() {
        this.getAllCategory();
    }

    // API operations
    getAllCategory = async () => {
        this.setState({ loading: true });
        try {
            const universityList = await _AdminService.GetAllUniversity();
            this.setState({
                data: universityList.data || [],
                loading: false
            });
        } catch (e) {
            console.error('Error fetching universities:', e);
            this.setState({ loading: false });
        }
    }

    handleUpdate = async () => {
        if (this.validateFormData()) return;

        const { Name, Fees, Id, IsBoard, IsDiploma } = this.state.rowData;
        const params = {
            Name: Name.trim(),
            Fees,
            Id,
            IsBoard,
            IsDiploma
        };

        this.setState({ loading: true });
        try {
            const response = await _AdminService.CreateUniversity(params);
            if (response.status === 200) {
                _notification.showMessage('success', "University saved successfully.");
                this.setState({
                    nameError: "",
                    showModel: false,
                    loading: false,
                    highlightedRowID: params.Id
                });
                this.getAllCategory();
            } else {
                _notification.showMessage('error', response.data.message);
                this.setState({ loading: false });
            }
        } catch (e) {
            console.error('Error saving university:', e);
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
            this.setState({ loading: false });
        }
    }

    handleDelete = async () => {
        try {
            const response = await _AdminService.DeleteUniversity(this.state.rowData.Id);
            if (response.status === 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "University deleted successfully.");
                this.setState({ nameError: "", showModel: false });
                this.getAllCategory();
            } else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            console.error('Error deleting university:', e);
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    // Table action link clicks
    onEditClick = (value) => {
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0 });
    };

    onDeleteClick = (value) => {
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination) => {
        this.setState({ pagination, highlightedRowID: 0 });
    }

    // Message box confirm delete click
    onConfirmDelete = () => {
        this.setState({ showMessageBox: false }, this.handleDelete);
    }

    closeMessageBox = (value = false) => {
        this.setState({ showMessageBox: value });
    }

    // Add new record click
    onAddNewRecordClick = (modelToggle) => {
        this.setState({ showModel: modelToggle, rowData: { IsBoard: false, IsDiploma: false } });
    }

    hideModelWindow = () => {
        this.setState({ showModel: false, rowData: { IsBoard: false, IsDiploma: false }, nameError: '' });
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name === 'Name' && value.length > 100) return;

        this.setState(prevState => ({
            rowData: {
                ...prevState.rowData,
                [name]: value
            }
        }));
    }

    onCheckedHandler = (event) => {
        const { name, checked } = event.target;
        this.setState(prevState => ({
            rowData: {
                ...prevState.rowData,
                [name]: checked
            }
        }));
    }

    validateFormData = () => {
        const { Name } = this.state.rowData;
        if (!Name || !Name.trim()) {
            this.setState({ nameError: 'Please enter valid University Name' });
            return true;
        }
        this.setState({ nameError: '' });
        return false;
    }

    render() {
        const TableColumns = [
            {
                title: 'University Name',
                dataIndex: 'Name',
                filterSearch: true,
                width: '85%',
                key: 'Name',
                sorter: (a, b) => a.Name.localeCompare(b.Name),
            },
            {
                title: 'Action',
                key: 'Id',
                render: (value) => (
                    <>
                        <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={() => this.onEditClick(value)} />
                        <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={() => this.onDeleteClick(value)} />
                    </>
                )
            },
        ];

        if (this.state.loading) return <LoadingSpinner />

        return (
            <div className="container-fluid p-3">
                <PageHeader
                    title="University Master"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'University Master' }]}
                />
                <div className="analysisWrap">
                    <div style={{ textAlign: 'right' }}>
                        {!this.state.showModel && (
                            <div className="max1200 m-auto mb-2">
                                <div className="d-flex align-items-center justify-content-end">
                                    <a
                                        className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3 mr-2 d-flex align-items-center justify-content-center"
                                        onClick={() => this.onAddNewRecordClick(true)}
                                    >
                                        <Icon type="plus-circle" className="mr-2 font1rem" /> Add University
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>

                    {this.state.showModel && (
                        <div className="max1200 m-auto">
                            <div className="ent-panel">
                                <h4 className="heading4">
                                    {this.state.rowData?.Id > 0 ? "Update" : "Add"} University
                                </h4>
                                <div className="admin-inner-wrap p-3">
                                    <div className="row flex-sm-row">
                                        <div className="mb-2 col-sm-8">
                                            <MyInput
                                                id="name"
                                                type="text"
                                                name="Name"
                                                heading="University Name"
                                                value={this.state.rowData.Name || ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.nameError}
                                                errorMessage={this.state.nameError}
                                            />
                                        </div>
                                        <div className="col-sm-2">
                                            <label style={{ visibility: "hidden" }}>asd</label>
                                            <Checkbox
                                                name="IsBoard"
                                                style={{ marginTop: "8px" }}
                                                onChange={this.onCheckedHandler}
                                                checked={this.state.rowData.IsBoard}
                                            >
                                                Board
                                            </Checkbox>
                                        </div>
                                        <div className="col-sm-2">
                                            <label style={{ visibility: "hidden" }}>asd</label>
                                            <Checkbox
                                                name="IsDiploma"
                                                style={{ marginTop: "8px" }}
                                                onChange={this.onCheckedHandler}
                                                checked={this.state.rowData.IsDiploma}
                                            >
                                                Diploma
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-4 buttonAlignCenter">
                                    <ButtonComponent type="button" value="Cancel" onClick={this.hideModelWindow} className="button-global button-secondary mr-4 autoHeight small" />
                                    <ButtonComponent type="button" value="Save" onClick={this.handleUpdate} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="max1200 m-auto">
                        <Table
                            size='small'
                            bordered
                            rowKey='Id'
                            columns={TableColumns}
                            dataSource={this.state.data}
                            pagination={this.state.pagination}
                            footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.data.length}</label>}
                            onChange={this.onTableAction}
                            rowClassName={(record, index) => (
                                index % 2
                                    ? 'odd' + (record.Id === this.state.highlightedRowID ? ' scroll-row table-row-dark' : '')
                                    : 'even' + (record.Id === this.state.highlightedRowID ? ' scroll-row table-row-dark' : '')
                            )}
                            className="table-striped-rows admin-table"
                            locale={{ emptyText: <EmptyState icon="inbox" title="No Records Found" description="No universities have been added yet." /> }}
                        />
                    </div>
                </div>

                <Modal
                    centered
                    width={400}
                    className="modelPopAnt admin-home"
                    visible={this.state.showMessageBox}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        popupData={this.state.rowData}
                        message="Are you sure, you want to delete this University?"
                    />
                </Modal>
            </div>
        )
    };
}

export default UniversityMaster_new;
